import React from "react";
import { observer } from "mobx-react";
import { Icon } from "antd";
import { WeaTop, WeaLocaleProvider } from "ecCom";

import MsgListPanel from "./msg-list-panel";
import MsgTypePanel from "./msg-type-panel";

import "../../style/index.less";
import SystemSet from "../systemSet";
import * as API from "../../apis/index";
import WeaMessageCenterStore from "../../stores/index";

const getLabel = WeaLocaleProvider.getLabel;
let newMsg = 0;

@observer
class MessageCenter extends React.PureComponent {
  static scroll = null;
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible,
      options: [],
      value: "",
      viewAttr: 2,
      loading: true,
      current: this.props.popIndex,
      systemSetVisiable: false,
      maxTimeFlag: false,
      rightList: [],
      msgid: "0",
      flag: true,
      maxtime: "0",
      mintime: "0",
      messagetype: "",
      title: "",
      newMsgValue: "none",
      unReadMsgValue: "none",
      msgList: [],
      count: 0,
      unReadCount: 0,
      searchVisible: false,
      keyword: "",
      tabSelectedKey: "0",
      tabFlag: "",
      tabData: [],
      moduleId: "",
      readedMsgIs: [],
      refresh: true,
      newGetMsgList: []
    };

    this.lastIndex = "";
    this.position = 0;
  }

  componentDidMount() {
    if (this.state.visible) {
      this.getMsgTypeList((current, item) => {
        this.changeRight(current, "0", "0", item);
      });
      this.getModule();
      clearInterval(newMsg);
      // newMsg = setInterval(() => {
      //   this.getNewMsgTypeNumberList();
      //   this.getNewMsgList(this.state.current, this.state.maxtime, 0);
      // }, this.props.intervalTime);
    }
    this.setState({ visible: this.props.visible });
  }

  componentWillUnmount() {
    clearInterval(newMsg);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ visible: nextProps.visible });
    // console.log(this.state.visible !== nextProps.visible);
    if (nextProps.popIndex !== this.props.popIndex) {
      this.setState({ current: nextProps.popIndex });
    }
    if (nextProps.visible) {
      if (this.state.visible !== nextProps.visible) {
        this.setState({ refresh: true }, () => {
          this.getMsgTypeList((current, item) => {
            this.changeRight(current, "0", "0", item);
          });
          this.getModule();
        });
      }
      clearInterval(newMsg);
      // newMsg = setInterval(() => {
      //   this.getNewMsgTypeNumberList();
      //   this.getNewMsgList(this.state.current, this.state.maxtime, 0);
      // }, nextProps.intervalTime);
    }
  }

  changeRight = (index, msgid1, mintime1, item) => {
    let tabFlag = "0";
    let datas = [];
    let tabData = [];
    if (item) {
      tabFlag = item.tabs && item.tabs.length > 0 ? "1" : "0";
      datas = item.tabs && item.tabs.length > 0 ? item.tabs : [];
    }

    if (tabFlag === "1") {
      tabData = JSON.parse(
        JSON.stringify(datas)
          .replace(/id/g, "viewcondition")
          .replace(/tabName/g, "title")
      );

      this.setState({
        tabSelectedKey: tabData[0].viewcondition
      });
    }
    this.setState(
      {
        tabFlag,
        tabData,
        refresh: true,
        msgList: [],
        selectState: tabData[0] ? tabData[0].selectState : ""
      },
      () => {
        if (item && Number(item.count) > 0) {
          this.setMsgRead(() => {
            this.getMsgList(
              index,
              msgid1,
              mintime1,
              res => {
                this.scroll && this.scroll.refs.weaBaron.scrollToLast();
              },
              false,
              true,
              "",
              true
            );
          });
        } else {
          this.getMsgList(
            index,
            msgid1,
            mintime1,
            res => {
              this.scroll && this.scroll.refs.weaBaron.scrollToLast();
            },
            false,
            true,
            "",
            true
          );
        }
      }
    );
  };

  getMsgTypeList = cb => {
    const { keyword, moduleId } = this.state;
    API.getMsgTypeNumberList({ groupid: moduleId, keyword }).then(res => {
      if (res.item) {
        const newArray = [];
        res.item.forEach(item => {
          newArray.push(item);
          // if (Number(item.count) > 0) {
          //   newArray.unshift(item);
          // } else {
          //   newArray.push(item);
          // }
        });
        // if (window.location.hash.indexOf("#/coms?id=WeaMessageCenter") === 0) {
        //   newArray.push({
        //     count: 97,
        //     flag: "",
        //     icon: "/cloudstore/images/icon/module/type018.png",
        //     id: "99",
        //     messageGroupType: "36",
        //     moduleId: "15",
        //     name: "test component",
        //     time: "2019-07-22 14:00:27",
        //     pc_url: "http://192.168.7.216:8080/spa/crm/static/index.html/#/main/crm/remindList?tdsourcetag=s_pctim_aiomsg&_key=8awmy6"
        //   });
        // }
        this.setState({
          rightList: newArray
        });
        //'点击小铃铛定位第一个
        let current = newArray[0] ? newArray[0].id : "0";
        if (Number(this.state.current) === 0) {
          this.setState({
            current
          });
        }
        if (cb && typeof cb === "function") {
          cb(this.props.popIndex || current, this.props.popItem || newArray[0]);
        }
      }
    });
  };

  getNewMsgTypeNumberList() {
    const { rightList, keyword, moduleId, maxtime } = this.state;
    API.getNewMsgTypeNumberList({ groupid: moduleId, maxtime, keyword }).then(
      res => {
        // res = {
        //   item: [
        //     { name: "全部", count: "1", id: "0" },
        //     { name: "提到我的", count: "2", id: "1,1" },
        //     { name: "关注流程提醒", count: "8", id: "2,9" },
        //     { name: "asdfasdf", count: "1", id: "99,99" }
        //   ],
        //   status: "1"
        // };
        if (res && res.item) {
          const newArray = [];
          for (let i = 0; i < res.item.length; i++) {
            for (let j = 0; j < rightList.length; j++) {
              if (res.item[i].id === rightList[j].id) {
                // rightList.splice(j, 1);
                rightList[j] = res.item[i];
              }
            }
          }
          // newArray.push(...res.item, ...rightList);
          this.setState({ rightList });
        }
      }
    );
  }

  setMsgRead = (cb = null) => {
    const newRightList = [];
    const index = this.state.current;
    this.state.rightList.forEach(item => {
      if (item.id === index) {
        item.count = 0;
      }
      newRightList.push(item);
    });
    this.setState({
      rightList: newRightList
    });
    API.setMsgRead({ id: this.state.current }).then(res => {
      // 更新小铃铛数字
      this.props.getMsgCount();
      if (cb && typeof cb === "function") {
        cb();
      }
    });
  };

  getNewMsgList = (index, maxtime1, readflag, cb) => {
    API.getNewMsgList({
      id: index,
      maxtime: maxtime1,
      flag: readflag
    }).then(res => {
      if (res) {
        if (res.newMessage === 1 && res.data.length > 0) {
          if (this.state.msgList.length === 0) {
            this.setState({
              mintime: res.mintime,
              msgid: res.msgid
            });
          }
          // interval event
          if (readflag === 0) {
            this.setState({
              newMsgValue: "block",
              messagetype: res.data[res.data.length - 1].name,
              count: res.data.length,
              title: res.data[res.data.length - 1].title
            });
          } else {
            // onClick event
            let newMsgList = [...this.state.msgList, ...res.data];
            this.setState(
              {
                newMsgValue: "none",
                msgList: newMsgList,
                maxtime: res.maxtime
              },
              () => {
                if (cb) {
                  cb();
                }
              }
            );
            // setTimeout(() => {
            // this.scroll.refs.weaBaron.scrollToLast();
            // }, 0);
          }
        } else {
          this.setState({
            newMsgValue: "none"
          });
        }
      } else {
        this.setState({
          newMsgValue: "none"
        });
      }
    });
  };

  getMsgList(
    index,
    msgid1,
    mintime1,
    cb,
    scroll = false,
    isUpdateMaxTime = true,
    bizstate1 = "",
    isInit = false,
    toLast = false
  ) {
    let bizstate = bizstate1;
    // 有分页
    if (this.state.tabFlag === "1") {
      this.state.tabData.forEach(item => {
        if (
          item.viewcondition === this.state.tabSelectedKey &&
          item.msgStateId
        ) {
          bizstate = item.msgStateId;
        }
      });
    }
    this.setState({ loading: true });

    API.getMsgList({
      id: index,
      pagesize: 20,
      msgid: msgid1,
      mintime: mintime1,
      bizstate,
      selectState: this.state.selectState
    }).then(res => {
      if (
        res.data &&
        !res.data.length &&
        isInit &&
        this.state.tabFlag === "1"
      ) {
        const allKeyArr = [];
        this.state.tabData.forEach(item => {
          if (!item.msgStateId) {
            bizstate = "";
            allKeyArr.push(item.viewcondition);
          }
        });
        if (!allKeyArr.length) {
          this.setState({
            tabSelectedKey: this.state.tabData[0].viewcondition,
            loading: false
          });
          return;
        }
        console.log(
          this,
          this.state.tabData.filter(item => item.viewcondition == allKeyArr[0])
            .selectState
        );
        this.setState(
          {
            tabSelectedKey: allKeyArr[0],
            selectState: this.state.tabData.filter(
              item => item.viewcondition == allKeyArr[0]
            )[0].selectState,
            refresh: true
          },
          () => {
            // bizstate = allKeyArr.length ? "" : this.state.tabData[0].msgStateId;
            this.getMsgList(
              index,
              msgid1,
              mintime1,
              "",
              true,
              true,
              "",
              false,
              true
            );
          }
        );
      } else {
        let msgList = [];

        if (this.state.refresh) {
          msgList = res.data.length > 0 ? res.data : [];
        } else {
          msgList = [...res.data, ...this.state.msgList];
        }
        setTimeout(() => {
          this.setState({ loading: false });
        }, 300);

        if (scroll) {
          // console.log(this.scroll.refs);
          window.scroll = this.scroll;
          // window.scroll.refs.weaBaron.getScroller().scrollTop =
          //   res.data.length * 200;
          // put this into Event queue
          setTimeout(() => {
            if (isInit || toLast) {
              this.scroll.refs.weaBaron.scrollToLast();
            }
          }, 0);
          // this.scroll.refs.weaBaron.scroll(4000);
        }
        this.setState({
          flag: true,
          mintime: res.mintime,
          msgid: res.msgid,
          refresh: false,
          newGetMsgList: res.data,
          msgList
        });
        if (isUpdateMaxTime) {
          this.setState({
            maxtime: res.maxtime
          });
        }
        if (cb && typeof cb === "function") {
          cb(res);
        }
      }
    });
  }

  getModule() {
    API.getModule().then(res => {
      if (res && res.options) {
        const newArray = res.options.map(item => {
          if (item.showname === "") {
            return Object.assign({}, item, {
              showname: getLabel("332", "全部")
            });
          }
          return item;
        });
        this.setState({
          options: newArray
        });
      }
    });
  }

  getMsgCount(mintime1) {
    API.getMsgCount({ mintime: mintime1 }).then(res => {
      if (res.count === 0) {
        this.setState({
          unReadCount: res.count,
          unReadMsgValue: "none"
        });
      } else
        this.setState({
          unReadCount: res.count,
          unReadMsgValue: "block"
        });
    });
  }

  advancedSearch = (type, v) => {
    switch (type) {
      default:
        break;
      case "search":
        break;
      case "reset":
        this.setState({
          keyword: "",
          moduleId: ""
        });
        break;
    }
    this.setState(
      {
        searchVisible: false,
        refresh: true
      },
      () => {
        this.getMsgTypeList();
        // this.getMsgList(0, 0, 0);
      }
    );
  };

  getReadedMsg(position, itemHeight = 200) {
    // console.log(position, this.position);
    const msgList = this.state.msgList;
    let unReadIndex = Math.floor(position / itemHeight) + 1;
    if (position < itemHeight) {
      unReadIndex = 0;
    }
    const temp = [];
    for (let i = unReadIndex; i < msgList.length; i++) {
      const readedItemId = msgList[i].messageid;
      temp.push(readedItemId);
    }
    if (temp.length > this.state.readedMsgIs.length) {
      // 已读调用暂时取消
      // API.setMsgRead({ msgid: temp.join(",") });
      this.setState({
        readedMsgIs: temp
      });
    }
    if (position) {
      // console.log(position < itemHeight && position - this.position < 0);
      if (position < itemHeight / 2 && position - this.position < 0) {
        this.setState({ flag: false });
        this.getMsgList(
          this.state.current,
          this.state.msgid,
          this.state.mintime,
          null,
          true,
          false
        );
      }
      this.position = position;
    }
  }

  onTopClick = () => this.setState({ systemSetVisiable: true });

  onRightIconClick = () => {
    typeof this.props.closeDialog === "function" && this.props.closeDialog();
  };

  onCancel = () => this.setState({ systemSetVisiable: false });

  changeState = (obj, cb) => {
    this.setState(obj, () => {
      if (cb) {
        cb();
      }
    });
  };

  onScroll = e => {
    this.scroll = e;
  };

  render() {
    const {
      options,
      viewAttr,
      current,
      moduleId,
      searchVisible,
      keyword,
      rightList,
      loading
    } = this.state;
    const offsetHeight = window.screen.height > 800 ? 0 : -80;
    return (
      <div ref={"__refs_messagecenter"}>
        <div className="wea-messageCenter-container">
          <div className="wea-messageCenter-topbar">
            <WeaTop
              buttons={[
                <i
                  onClick={this.onTopClick}
                  className="icon-coms-Flow-setting right-icon"
                />,
                <Icon
                  className="right-icon"
                  onClick={this.onRightIconClick}
                  type="cross"
                />
              ]}
            />
          </div>
          <div
            style={offsetHeight === 0 ? {} : { height: 600 + offsetHeight }}
            className="wea-messageCenter-content"
          >
            <MsgTypePanel
              offsetHeight={offsetHeight}
              options={options}
              moduleId={moduleId}
              viewAttr={viewAttr}
              setState={this.changeState}
              keyword={keyword}
              searchVisible={searchVisible}
              rightList={rightList}
              current={current}
              loading={loading}
              changeRight={this.changeRight}
              advancedSearch={this.advancedSearch}
            />
            <MsgListPanel
              offsetHeight={offsetHeight}
              setState={this.changeState}
              unReadMsgValue={this.state.unReadMsgValue}
              tabFlag={this.state.tabFlag}
              tabData={this.state.tabData}
              tabSelectedKey={this.state.tabSelectedKey}
              msgList={this.state.msgList}
              currentMsgType={this.state.rightList.filter(
                item => item.id === this.state.current
              )}
              loading={this.state.loading}
              newMsgValue={this.state.newMsgValue}
              messagetype={this.state.messagetype}
              newGetMsgList={this.state.newGetMsgList}
              title={this.state.title}
              count={this.state.count}
              current={this.state.current}
              msgid={this.state.msgid}
              mintime={this.state.mintime}
              scroll={this.onScroll}
              getReadedMsg={params => {
                this.getReadedMsg(params);
              }}
              getMsgList={(
                a,
                b,
                c,
                d,
                scroll,
                isUpdateMaxTime,
                bizstate,
                isInit,
                toLast
              ) => {
                this.getMsgList(
                  a,
                  b,
                  c,
                  d,
                  scroll,
                  isUpdateMaxTime,
                  bizstate,
                  isInit,
                  toLast
                );
              }}
              getNewMsgList={this.getNewMsgList}
              getMsgTypeList={this.getMsgTypeList}
              setMsgRead={this.setMsgRead}
              customComponent={this.props.customComponent}
            />
          </div>
        </div>
        <SystemSet
          getMsgTypeList={this.getMsgTypeList}
          systemSetStore={WeaMessageCenterStore}
          visible={this.state.systemSetVisiable}
          onCancel={this.onCancel}
        />
      </div>
    );
  }
}

export default MessageCenter;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/message-center/index.js